import { Component, OnInit } from '@angular/core';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-error-server-down',
  templateUrl: './error-server-down.component.html',
  styleUrls: ['./error-server-down.component.css']
})
export class ErrorServerDownComponent implements OnInit {

  constructor(
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
   }

  ngOnInit(): void {
  }

}
